import axios, { AxiosInstance, AxiosResponse } from 'axios';
import { eventService } from "./EventService";
import IHttpService from '@/interfaces/IHttpService';
import { Response } from '../model/Response';

export default class HttpService implements IHttpService {
    private _root: string = "";
    private _timeout: number = 5000;
    private instance: AxiosInstance = axios.create();

    get(url: string) {
        this.checkToken();
        return this.instance.get(url).then(this.processResponse).catch(this.processError);
    }
    delete(url: string) {
        this.checkToken();
        return this.instance.delete(url).then(this.processResponse).catch(this.processError);
    }

    post(url: string, params: any) {
        this.checkToken();
        return this.instance.post(url, params).then(this.processResponse).catch(this.processError);
    }

    put(url: string, params: any) {
        this.checkToken();
        return this.instance.put(url, params).then(this.processResponse).catch(this.processError);
    }

    private processResponse(response: AxiosResponse): Promise<any> {
        return new Promise((resolve: any, reject: any) => {
            const res = <Response>response.data;

            if (res.Error) {
                reject(res);
            } else {
                if (res.Body) {
                    resolve(res.Body);
                }
                else {
                    resolve(response.data);
                }

            }
        });
    }

    private processError(error: any) {
        return new Promise((resolve: any, reject: any) => {
            if (error.Error) {
                if(error.Level === 'Error'){
                    eventService.emit('toast-message', { Level: error.Level.toLowerCase(), Message: 'Ha ocurrido un error en el servidor.' });
                }else{
                    eventService.emit('toast-message', { Level: error.Level.toLowerCase(), Message: error.Message });
                }
                console.error(error.Message);
                reject(error.Message);
            } 
            else 
            {
                if (error && error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                    if(error.response.status === 401){
                        eventService.emit('401 Unauthorized', true);
                    }
                } else if (error && error.request) {
                    console.log(error.request);
                }
                console.log(error);
                reject(error);
            }
        });
    }

    tokenRemove(){
        localStorage.removeItem("token");
        this.instance.defaults.headers.APIKEY = "";
    }

    checkToken(){
        let token = this.token;
        if(token !== ""){
            this.instance.defaults.headers.APIKEY = token;
        }
    }

    set token(valor: string) {
        localStorage.setItem("token", valor);
        this.instance.defaults.headers.APIKEY = valor;
    }

    get token() {
        return localStorage.getItem("token")+"";
    }

    set root(valor: string) {
        this._root = valor;
        this.instance.defaults.baseURL = valor;
    }

    get root() {
        return this._root;
    }

    set timeout(valor: number) {
        this._timeout = valor;
        this.instance.defaults.timeout = valor;
    }

    get timeout() {
        return this._timeout;
    }
}

export const httpService = new HttpService();